export var ChartComponents;
(function (ChartComponents) {
    ChartComponents["CHARTCOMPONENT"] = "ChartComponent";
    ChartComponents["CO2CHARTCOMPONENT"] = "Co2ChartComponent";
    ChartComponents["ADMINLOGGERCHART"] = "AdminLoggerChart";
    ChartComponents["SOURCETABS"] = "SourceTabs";
    ChartComponents["REPORTSOVERALLCHART"] = "ReportsOverallChart";
    ChartComponents["CO2REPORTSCHART"] = "Co2ReportsChart";
    ChartComponents["ANNOTATIONCHART"] = "AnnotationChart";
})(ChartComponents || (ChartComponents = {}));
